exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".LoginElements-Logo-Header_logo{display:block;width:190px;position:absolute;top:50%;left:0;-webkit-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%)}.LoginElements-Logo-Header_logo img{max-width:100%}@media (min-width:721px){.LoginElements-Logo-Header_logo{width:200px;left:50%;margin:0;-webkit-transform:translateX(-50%) translateY(-50%);-ms-transform:translateX(-50%) translateY(-50%);transform:translateX(-50%) translateY(-50%)}}.LoginElements-Logo-logo{position:relative}", ""]);

// exports
exports.locals = {
	"Header_logo": "LoginElements-Logo-Header_logo",
	"logo": "LoginElements-Logo-logo"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--2-rules-2!./node_modules/postcss-loader/lib??ref--2-rules-3!./src/components/LoginElements/Logo.css
// module id = 1447
// module chunks = 0 9